import { render, staticRenderFns } from "./baogaoJcDetail.vue?vue&type=template&id=7ce874b4&scoped=true"
import script from "./baogaoJcDetail.vue?vue&type=script&lang=js"
export * from "./baogaoJcDetail.vue?vue&type=script&lang=js"
import style0 from "./baogaoJcDetail.vue?vue&type=style&index=0&id=7ce874b4&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce874b4",
  null
  
)

export default component.exports